
/*
 * Date: 2023
 * Description: Banking page needs to be designed
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { Box } from "@mui/material"
import { ReactElement } from "react"

//Interfaces && types
import { i_initial_props } from "../interfaces/utility.interface"

const Banking = ( props : i_initial_props ) : ReactElement => {
    return (
        <Box>

        </Box>
    )
}


export default Banking